<template>
  <div class="coverflow-swiper-container">
    <div class="coverflow-swiper-container-title"> {{ data?.title ?? '' }}</div>
    <swiper
        class="coverflow-swiper"
        :modules=modules
        :pagination="false"
        :loop="true"
        :autoplay="{ delay: 2000, disableOnInteraction: false }"
        :effect="'coverflow'"
        :slides-per-view="3"
        :centered-slides="false"
        :coverflow-effect="{
          rotate: 47,
          stretch: 0,
          depth:300,
          slideShadows: false,
          modifier: 1,
          scale: 1.0
      }"
    >
      <swiper-slide class="coverflow-swiper-slide" v-for="(item, index) in extendedImages" :key="index">
        <img v-lazy="item?.url ?? ''" alt="" draggable="false" :style="{ objectFit: 'cover' , objectPosition: 'center'}"/>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script setup>
import {Swiper, SwiperSlide} from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/effect-coverflow'
import {Autoplay, EffectCoverflow, Pagination} from 'swiper/modules'

const modules = [EffectCoverflow, Pagination, Autoplay]

const props = defineProps({
  jsonData: Object,
})

const data = reactive(props.jsonData)
const imageList = reactive([])

onBeforeMount(() => {
  imageList.push(...data.data.content)
})

// 将图片列表重复一份，以实现无缝滚动
const extendedImages = computed(() => [...imageList, ...imageList, ...imageList, ...imageList, ...imageList])

</script>

<script>
export default {
  name: 'CoverflowImageView'
}
</script>

<style scoped lang="less">
.coverflow-swiper-container {
  width: 100%;
  height: 270px; /* Set the desired height */
  margin-top: 50px;
  overflow: hidden;

  .coverflow-swiper-container-title {
    font-size: 18px;
    color: var(--main-color);
    letter-spacing: 2px;
    font-weight: bold;
    margin-bottom: 30px;
  }

  .coverflow-swiper {
    width: 100%;
    height: auto;

    .coverflow-swiper-slide {
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 100%; /* 图片宽度始终填充父容器 */
        max-width: 320px; /* 限制最大宽度，防止图片太大 */
        height: auto; /* 保持宽高比 */
        object-fit: cover; /* 确保图片内容适应容器 */
      }
    }
  }

}

</style>
